/**
 * Callout badge and scientific annotation label with pill background.
 */
import { SVGObject, SVGObjectConfig } from './SVGObject';
import { Renderer } from '../core/Renderer';

export interface LabelProps {
  text: string;
  badgeColor?: string;
  textColor?: string;
  fontSize?: number;
  paddingX?: number;
  paddingY?: number;
  borderRadius?: number;
}

export class Label extends SVGObject {
  public props: LabelProps;

  constructor(config: SVGObjectConfig & { props?: LabelProps }) {
    super({ ...config, type: 'label' });
    this.props = {
      text: 'Label',
      badgeColor: '#1e293b',
      textColor: '#38bdf8',
      fontSize: 16,
      paddingX: 14,
      paddingY: 6,
      borderRadius: 8,
      ...config.props
    };
  }

  public render(): void {
    this.container.innerHTML = '';
    const fontSize = this.props.fontSize || 16;
    const padX = this.props.paddingX || 14;
    const padY = this.props.paddingY || 6;
    const textLen = (this.props.text || '').length;
    const approxW = Math.max(60, textLen * fontSize * 0.65 + padX * 2);
    const approxH = fontSize + padY * 2 + 4;

    // Background pill
    const bg = Renderer.createElement('rect');
    Renderer.setAttributes(bg, {
      x: -approxW / 2,
      y: -approxH / 2,
      width: approxW,
      height: approxH,
      rx: this.props.borderRadius || 8,
      ry: this.props.borderRadius || 8,
      fill: this.props.badgeColor || '#1e293b',
      stroke: this.props.textColor || '#38bdf8',
      'stroke-width': 1.5
    });
    this.container.appendChild(bg);

    // Text
    const textEl = Renderer.createElement('text');
    Renderer.setAttributes(textEl, {
      x: 0,
      y: 0,
      'font-size': fontSize,
      'font-family': 'Inter, sans-serif',
      'font-weight': '600',
      fill: this.props.textColor || '#38bdf8',
      'text-anchor': 'middle',
      'dominant-baseline': 'central'
    });
    textEl.textContent = this.props.text || '';
    this.container.appendChild(textEl);
  }
}
